<ng-template #noPasses>
	<div class="no-passes">
		<div class="icon-container">
			<img style="width: 40px; height: 77px" [src]="'/assets/icon-walker-light-gray.svg'" alt="Lone Walker" />
		</div>
		<p>Going Somewhere?</p>
		<app-create-pass-button
			cdkOverlayOrigin
			#secondOverlayTrigger="cdkOverlayOrigin"
			[title]="'Create Pass'"
			[backgroundColor]="'#00B476'"
			[hoverBackgroundColor]="'#009964'"
			[icon]="'add-icon.svg'"
			[textColor]="'#fff'"
			[hoverText]="emergencyService.isEmergencyActivated.value ? 'An emergency is active.' : homePageService.createButtonTooltipText"
			(mouseenter)="homePageService.showSecondStudentNoFlyTimeTooltip()"
			(mouseleave)="homePageService.closeSecondStudentNoFlyTimeTooltip()"
			[disabled]="
				emergencyService.isEmergencyActivated.value ||
				(homePageService.isActivePass$ | async) ||
				homePageService.hasActivePassRequest ||
				homePageService.noFlyTimeActive
			"
			(onClick)="homePageService.showMainForm(false)">
		</app-create-pass-button>
		<ng-template
			cdkConnectedOverlay
			[cdkConnectedOverlayOrigin]="secondOverlayTrigger"
			[cdkConnectedOverlayOpen]="homePageService.isSecondOpenStudentNoFlyTimeTooltip | async"
			[cdkConnectedOverlayWidth]="198"
			[cdkConnectedOverlayHeight]="89"
			[cdkConnectedOverlayPositions]="homePageService.noFlyTimeTooltipPosition">
			<app-no-fly-time-tooltip
				*ngIf="homePageService.noFlyTimeActive && !homePageService.hasActivePassRequest"
				[noFlyTimes]="homePageService.noFlyTimes"
				[isStaff]="false"
				[tooltipType]="'student'"
				[currentNoFlyTimeIndex]="homePageService.currentNoFlyTimeIndex"
				(mouseleave)="homePageService.closeSecondStudentNoFlyTimeTooltip()"
				(mouseover)="homePageService.showSecondStudentNoFlyTimeTooltip()">
			</app-no-fly-time-tooltip>
		</ng-template>
	</div>
</ng-template>

<!-- BEGIN ALL SCREEN SIZE DISPLAY -->
<div class="passes-wrapper" (scroll)="homePageService.scroll($event)" [style.overflow]="'visible'" *ngIf="effectiveUser">
	<div class="main-page-left">
		<div class="date-time-header" *ngIf="scheduleService.myScheduleForToday$ | async as schedule; else noSchedule">
			<!-- holiday -->
			<ng-container *ngIf="!isWeekend">
				<div *ngIf="schedule" class="tw-flex tw-items-center tw-text-navy-500 tw-font-normal tw-text-lg">
					<img *ngIf="schedule?.holiday" class="tw-w-5 tw-mr-1" [src]="'./assets/holiday.png'" alt="" />
					<p class="tw-m-0">{{ schedule?.holiday?.name }}</p>
				</div>
				<ng-container *ngIf="scheduleService.scheduleGroup$ | async as scheduleGroup">
					<span *ngIf="!schedule?.holiday?.name" class="tw-m-0"> Today is {{ scheduleGroup.day_name }} Day </span>
				</ng-container>
			</ng-container>

			<!-- weekend -->
			<div *ngIf="isWeekend" class="tw-flex tw-items-center tw-text-navy-500 tw-font-normal tw-text-lg">
				<img class="tw-w-5 tw-mr-1" [src]="'./assets/weekend.png'" alt="" />
				<p class="tw-m-0">Weekend</p>
			</div>

			<div class="tw-text-navy-500 tw-font-bold tw-text-2xl tw-mt-1" *ngIf="homePageService.clock | async as date">
				{{ date | momentFormatPipe : 'dddd, MMM D' }}
				<!-- <img class="ellispe-icon" [src]="'./assets/Ellipse (Gray500).svg' | resolveAsset" /> -->
				<!-- <span [ngClass]="{ 'no-fly-time-text': homePageService.noFlyTimeActive }" class="time">{{ date | date : 'h:mm a' }}</span> -->
				<div
					cdkOverlayOrigin
					#thirdOverlayTrigger="cdkOverlayOrigin"
					class="no-fly-time-bubble tw-mt-2"
					(mouseenter)="homePageService.showNoFlyTimeTooltip()"
					(mouseleave)="homePageService.closeNoFlyTimeTooltip()"
					[style.visibility]="homePageService.noFlyTimeActive ? '' : 'hidden'">
					<img *ngIf="homePageService.noFlyTimeActive" class="no-fly-time-icon" [src]="'./assets/no-fly-time (2).svg' | resolveAsset" />
					<span *ngIf="homePageService.noFlyTimeActive">UNTIL {{ homePageService.currentNoFlyEndTimeString }}</span>
				</div>
				<ng-template
					cdkConnectedOverlay
					[cdkConnectedOverlayOrigin]="thirdOverlayTrigger"
					[cdkConnectedOverlayOpen]="homePageService.isOpenNoFlyTimeTooltip | async"
					[cdkConnectedOverlayWidth]="197"
					[cdkConnectedOverlayHeight]="homePageService.noFlyTimeTooltipHeight"
					[cdkConnectedOverlayPositions]="homePageService.noFlyTimeTooltipPosition">
					<app-no-fly-time-tooltip
						*ngIf="homePageService.noFlyTimeActive && !homePageService.hasActivePassRequest"
						[noFlyTimes]="homePageService.noFlyTimes"
						[tooltipType]="'staff'"
						[isStaff]="false"
						[currentNoFlyTimeIndex]="homePageService.currentNoFlyTimeIndex"
						(mouseleave)="homePageService.closeNoFlyTimeTooltip()"
						(mouseover)="homePageService.showNoFlyTimeTooltip()">
					</app-no-fly-time-tooltip>
				</ng-template>
				<ng-template
					cdkConnectedOverlay
					[cdkConnectedOverlayOrigin]="overlayTrigger"
					[cdkConnectedOverlayOpen]="homePageService.isOpenNoFlyTimeNuxTooltip | async"
					[cdkConnectedOverlayWidth]="197"
					[cdkConnectedOverlayHeight]="homePageService.noFlyTimeTooltipHeight"
					[cdkConnectedOverlayPositions]="homePageService.noFlyTimeTooltipPosition">
				</ng-template>
			</div>
		</div>
		<ng-template #noSchedule>
			<div class="date-time-header no-schedule-enabled">
				<div class="date-time" *ngIf="homePageService.clock | async as date">
					{{ date | momentFormatPipe : 'dddd, MMMM Do' }}
					<img class="ellispe-icon" [src]="'./assets/Ellipse (Gray500).svg' | resolveAsset" />
					<span [ngClass]="{ 'no-fly-time-text': homePageService.noFlyTimeActive }" class="time">{{ date | date : 'h:mm a' }}</span>
					<div
						cdkOverlayOrigin
						#thirdOverlayTrigger="cdkOverlayOrigin"
						class="no-fly-time-bubble"
						(mouseenter)="homePageService.showNoFlyTimeTooltip()"
						(mouseleave)="homePageService.closeNoFlyTimeTooltip()"
						[style.visibility]="homePageService.noFlyTimeActive ? '' : 'hidden'">
						<img *ngIf="homePageService.noFlyTimeActive" class="no-fly-time-icon" [src]="'./assets/no-fly-time (2).svg' | resolveAsset" />
						<span *ngIf="homePageService.noFlyTimeActive">UNTIL {{ homePageService.currentNoFlyEndTimeString }}</span>
					</div>
					<ng-template
						cdkConnectedOverlay
						[cdkConnectedOverlayOrigin]="thirdOverlayTrigger"
						[cdkConnectedOverlayOpen]="homePageService.isOpenNoFlyTimeTooltip | async"
						[cdkConnectedOverlayWidth]="197"
						[cdkConnectedOverlayHeight]="homePageService.noFlyTimeTooltipHeight"
						[cdkConnectedOverlayPositions]="homePageService.noFlyTimeTooltipPosition">
						<app-no-fly-time-tooltip
							*ngIf="homePageService.noFlyTimeActive && !homePageService.hasActivePassRequest"
							[noFlyTimes]="homePageService.noFlyTimes"
							[tooltipType]="'staff'"
							[isStaff]="false"
							[currentNoFlyTimeIndex]="homePageService.currentNoFlyTimeIndex"
							(mouseleave)="homePageService.closeNoFlyTimeTooltip()"
							(mouseover)="homePageService.showNoFlyTimeTooltip()">
						</app-no-fly-time-tooltip>
					</ng-template>
					<ng-template
						cdkConnectedOverlay
						[cdkConnectedOverlayOrigin]="overlayTrigger"
						[cdkConnectedOverlayOpen]="homePageService.isOpenNoFlyTimeNuxTooltip | async"
						[cdkConnectedOverlayWidth]="197"
						[cdkConnectedOverlayHeight]="homePageService.noFlyTimeTooltipHeight"
						[cdkConnectedOverlayPositions]="homePageService.noFlyTimeTooltipPosition">
					</ng-template>
				</div>
			</div>
			<div class="greeting">{{ homePageService.greetingOrPeriod }}, {{ effectiveUser.first_name }}!</div>
		</ng-template>
		<div class="pass-buttons" [ngStyle]="{ display: screenService.windowWidth < homePageService.navBarBreakPoint ? 'flex' : 'none' }">
			<app-create-pass-button
				[title]="'Schedule Pass'"
				[disabled]="emergencyService.isEmergencyActivated.value"
				[hoverText]="emergencyService.isEmergencyActivated.value ? 'An emergency is active.' : ''"
				(onClick)="homePageService.showMainForm(true)"></app-create-pass-button>
			<app-create-pass-button
				cdkOverlayOrigin
				#overlayTrigger="cdkOverlayOrigin"
				[title]="'Create Pass'"
				[backgroundColor]="'#00B476'"
				[hoverBackgroundColor]="'#009964'"
				[icon]="'add-icon.svg'"
				[textColor]="'#fff'"
				[hoverText]="emergencyService.isEmergencyActivated.value ? 'An emergency is active.' : homePageService.createButtonTooltipText"
				(mouseenter)="homePageService.showStudentNoFlyTimeTooltip()"
				(mouseleave)="homePageService.closeStudentNoFlyTimeTooltip()"
				[disabled]="
					emergencyService.isEmergencyActivated.value ||
					(homePageService.isActivePass$ | async) ||
					homePageService.hasActivePassRequest ||
					homePageService.noFlyTimeActive
				"
				(onClick)="homePageService.showMainForm(false)">
			</app-create-pass-button>
			<ng-template
				cdkConnectedOverlay
				[cdkConnectedOverlayOrigin]="overlayTrigger"
				[cdkConnectedOverlayOpen]="homePageService.isOpenStudentNoFlyTimeTooltip | async"
				[cdkConnectedOverlayWidth]="189"
				[cdkConnectedOverlayHeight]="89"
				[cdkConnectedOverlayPositions]="homePageService.noFlyTimeTooltipPosition">
				<app-no-fly-time-tooltip
					*ngIf="homePageService.noFlyTimeActive && !homePageService.hasActivePassRequest"
					[noFlyTimes]="homePageService.noFlyTimes"
					[tooltipType]="'student'"
					[isStaff]="false"
					[currentNoFlyTimeIndex]="homePageService.currentNoFlyTimeIndex"
					(mouseleave)="homePageService.closeStudentNoFlyTimeTooltip()"
					(mouseover)="homePageService.showStudentNoFlyTimeTooltip()">
				</app-no-fly-time-tooltip>
			</ng-template>
		</div>

		<ng-container *ngIf="activityStudentHomeFF; else noActivities">
			<ng-container *ngIf="homePageService._studentHasPassesOrActivities | async; else noPasses">
				<div class="current-pass" [style.cursor]="'pointer'">
					<div class="center">
						<!-- show create pass button if no active current pass or wait in line pass -->
						<ng-container
							*ngIf="
								!(homePageService.currentPass$ | async) &&
								!(homePageService.currentWaitInLine$ | async) &&
								!(homePageService.currentRequestForStudent$ | async)
							">
							<div class="create-button-wrapper">
								<app-create-pass-button
									cdkOverlayOrigin
									#thirdOverlayTrigger="cdkOverlayOrigin"
									(mouseenter)="homePageService.showThirdStudentNoFlyTimeTooltip()"
									(mouseleave)="homePageService.closeThirdStudentNoFlyTimeTooltip()"
									[title]="'Create Pass'"
									[backgroundColor]="'#00B476'"
									[hoverBackgroundColor]="'#009964'"
									[icon]="'add-icon.svg'"
									[textColor]="'#fff'"
									[hoverText]="emergencyService.isEmergencyActivated.value ? 'An emergency is active.' : ''"
									[disabled]="
										emergencyService.isEmergencyActivated.value ||
										(homePageService.isActivePass$ | async) ||
										homePageService.hasActivePassRequest ||
										homePageService.noFlyTimeActive
									"
									(onClick)="homePageService.showMainForm(false)">
								</app-create-pass-button>
								<ng-template
									cdkConnectedOverlay
									[cdkConnectedOverlayOrigin]="thirdOverlayTrigger"
									[cdkConnectedOverlayOpen]="homePageService.isThirdOpenStudentNoFlyTimeTooltip | async"
									[cdkConnectedOverlayWidth]="198"
									[cdkConnectedOverlayHeight]="89"
									[cdkConnectedOverlayPositions]="homePageService.noFlyTimeTooltipPosition">
									<app-no-fly-time-tooltip
										*ngIf="homePageService.noFlyTimeActive && !homePageService.hasActivePassRequest"
										[noFlyTimes]="homePageService.noFlyTimes"
										[isStaff]="false"
										[tooltipType]="'student'"
										[currentNoFlyTimeIndex]="homePageService.currentNoFlyTimeIndex"
										(mouseleave)="homePageService.closeThirdStudentNoFlyTimeTooltip()"
										(mouseover)="homePageService.showThirdStudentNoFlyTimeTooltip()">
									</app-no-fly-time-tooltip>
								</ng-template>
							</div>
						</ng-container>
	
						<sp-student-active-pass
							*ngIf="homePageService.currentPass$ | async as pass"
							[pass]="pass"
							[heartbeat]="homePageService.heartBeat"
							(click)="homePageService.openPassDialog(pass, true, false)"
							(openPassModal)="homePageService.openPassDialog(pass, true, true)"></sp-student-active-pass>
						<sp-student-wait-in-line-pass
							*ngIf="homePageService.currentWaitInLine$ | async as currentWil"
							collection-content
							[pass]="currentWil"
							(click)="homePageService.openPassDialog(currentWil, true, false)"></sp-student-wait-in-line-pass>
	
						<sp-pass-tile-large
							*ngIf="homePageService.currentRequestForStudent$ | async as req"
							collection-content
							[isStaff]="false"
							[isStudent]="true"
							[studentName]="effectiveUser.display_name"
							[roomName]="req.destination.title"
							[roomIcon]="req.icon"
							[startTime]="req.request_time"
							[colorProfile]="req.color_profile"
							[status]="req.status"
							(click)="homePageService.openPassDialog(req, true, false)"></sp-pass-tile-large>
					</div>
				</div>
						<sp-future-passes-activities [effectiveUser]="effectiveUser"></sp-future-passes-activities>
			</ng-container>	
		</ng-container>

		<ng-template #noActivities>
			<ng-container *ngIf="homePageService._studentHasPasses | async; else noPasses">
				<div class="current-pass" [style.cursor]="'pointer'">
					<div class="center">
						<!-- show create pass button if no active current pass or wait in line pass -->
						<ng-container
							*ngIf="
								!(homePageService.currentPass$ | async) &&
								!(homePageService.currentWaitInLine$ | async) &&
								!(homePageService.currentRequestForStudent$ | async)
							">
							<div class="create-button-wrapper">
								<app-create-pass-button
									cdkOverlayOrigin
									#thirdOverlayTrigger="cdkOverlayOrigin"
									(mouseenter)="homePageService.showThirdStudentNoFlyTimeTooltip()"
									(mouseleave)="homePageService.closeThirdStudentNoFlyTimeTooltip()"
									[title]="'Create Pass'"
									[backgroundColor]="'#00B476'"
									[hoverBackgroundColor]="'#009964'"
									[icon]="'add-icon.svg'"
									[textColor]="'#fff'"
									[hoverText]="emergencyService.isEmergencyActivated.value ? 'An emergency is active.' : ''"
									[disabled]="
										emergencyService.isEmergencyActivated.value ||
										(homePageService.isActivePass$ | async) ||
										homePageService.hasActivePassRequest ||
										homePageService.noFlyTimeActive
									"
									(onClick)="homePageService.showMainForm(false)">
								</app-create-pass-button>
								<ng-template
									cdkConnectedOverlay
									[cdkConnectedOverlayOrigin]="thirdOverlayTrigger"
									[cdkConnectedOverlayOpen]="homePageService.isThirdOpenStudentNoFlyTimeTooltip | async"
									[cdkConnectedOverlayWidth]="198"
									[cdkConnectedOverlayHeight]="89"
									[cdkConnectedOverlayPositions]="homePageService.noFlyTimeTooltipPosition">
									<app-no-fly-time-tooltip
										*ngIf="homePageService.noFlyTimeActive && !homePageService.hasActivePassRequest"
										[noFlyTimes]="homePageService.noFlyTimes"
										[isStaff]="false"
										[tooltipType]="'student'"
										[currentNoFlyTimeIndex]="homePageService.currentNoFlyTimeIndex"
										(mouseleave)="homePageService.closeThirdStudentNoFlyTimeTooltip()"
										(mouseover)="homePageService.showThirdStudentNoFlyTimeTooltip()">
									</app-no-fly-time-tooltip>
								</ng-template>
							</div>
						</ng-container>
	
						<sp-student-active-pass
							*ngIf="homePageService.currentPass$ | async as pass"
							[pass]="pass"
							[heartbeat]="homePageService.heartBeat"
							(click)="homePageService.openPassDialog(pass, true, false)"
							(openPassModal)="homePageService.openPassDialog(pass, true, true)"></sp-student-active-pass>
						<sp-student-wait-in-line-pass
							*ngIf="homePageService.currentWaitInLine$ | async as currentWil"
							collection-content
							[pass]="currentWil"
							(click)="homePageService.openPassDialog(currentWil, true, false)"></sp-student-wait-in-line-pass>
	
						<sp-pass-tile-large
							*ngIf="homePageService.currentRequestForStudent$ | async as req"
							collection-content
							[isStaff]="false"
							[isStudent]="true"
							[studentName]="effectiveUser.display_name"
							[roomName]="req.destination.title"
							[roomIcon]="req.icon"
							[startTime]="req.request_time"
							[colorProfile]="req.color_profile"
							[status]="req.status"
							(click)="homePageService.openPassDialog(req, true, false)"></sp-pass-tile-large>
					</div>
				</div>
					<div class="pass-collection future-passes">
						<sp-pass-collection-v2>
							<sp-collection-title>Upcoming This Week</sp-collection-title>
							<sp-pass-tile-large
								collection-content
								*ngFor="let pass of homePageService.futurePasses2ForStudents"
								[isStaff]="false"
								[isStudent]="true"
								[studentName]="effectiveUser.display_name"
								[roomName]="pass.destination.title"
								[roomIcon]="pass.icon"
								[startTime]="pass.start_time"
								[endTime]="pass.expiration_time"
								[colorProfile]="pass.color_profile"
								(click)="homePageService.openPassDialog(pass, true, false)"></sp-pass-tile-large>
						</sp-pass-collection-v2>
					</div>
			</ng-container>				
		</ng-template>
	</div>
	<sp-pass-requests-sidebar
		[isStaff]="false"
		[receivedRequests2]="homePageService.receivedRequests2"
		[activeTabIndex]="homePageService.activeTabIndex"
		[sortIconData]="homePageService.sortIconData"
		[_showRequestTitles]="homePageService._showRequestTitles"
		[emptyPassRequestMessage]="homePageService.emptyPassRequestMessage"
		[isStudent]="true"
		(openPassDialog)="homePageService.openPassDialogFromSidebar($event)">
	</sp-pass-requests-sidebar>
</div>
